module.exports = __webpack_public_path__ + "img/apply.1eb4bd44.png";